import { render, staticRenderFns } from "./ModalCapacitaciones.vue?vue&type=template&id=07ea7590&"
import script from "./ModalCapacitaciones.vue?vue&type=script&lang=ts&"
export * from "./ModalCapacitaciones.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCapacitaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('07ea7590', component.options)
    } else {
      api.reload('07ea7590', component.options)
    }
    module.hot.accept("./ModalCapacitaciones.vue?vue&type=template&id=07ea7590&", function () {
      api.rerender('07ea7590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Capacitaciones/ModalCapacitaciones.vue"
export default component.exports